var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tag",class:{'search-tag--active':_vm.active},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("prefix"),_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("suffix")],2)}
var staticRenderFns = []

export { render, staticRenderFns }